import MediaGallerySelector from './MediaGallerySelector';

export default MediaGallerySelector;
